import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-left",
  "use": "icon-chevron-left-usage",
  "viewBox": "0 0 8 14",
  "content": "<symbol viewBox=\"0 0 8 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-chevron-left\">\n<path d=\"M7 13.7487C7.19 13.7487 7.38 13.6787 7.53 13.5287C7.82 13.2387 7.82 12.7587 7.53 12.4687L2.06 6.99872L7.53 1.52872C7.82 1.23872 7.82 0.758721 7.53 0.468721C7.24 0.178721 6.76 0.178721 6.47 0.468721L0.469998 6.46872C0.179998 6.75872 0.179998 7.23872 0.469998 7.52872L6.47 13.5287C6.62 13.6787 6.81 13.7487 7 13.7487Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol